// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-membership-status-request-schema',
  type: 'object',
  required: ['membershipKey'],
  properties: {
    membershipKey: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
